import defineMessages from "../../../common/helpers/defineMessages";

const messages = defineMessages({
    back: {
        id: "general.back",
    },
    comments: {
        id: "test.comments",
    },
    notFound: {
        id: "error.404.title",
    },
    listed: {
        id: "planCard.listed",
    },
    start: {
        id: "welcome.start",
    },
    moreInfo: {
        id: "promo.moreInfo",
    },
    promoQuestion: {
        id: "promo.question",
    },
});

export default messages;
